import React from 'react';
import { Navigate, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import MainLayout from '../../../app/layouts/MainLayout';
import { useTrimesters } from '../../trimesters/context/TrimestersContext';
import EbdReportsHubView from '../components/EbdReportsHubView';
import OfferingsReportView from '../components/OfferingsReportView';
import { getReportById } from '../services/report.service';

const ReportDetailsPage = () => {
  const { reportId } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const reportDefinition = getReportById(reportId);
  const { currentTrimester, currentTrimesterId } = useTrimesters();
  const routeTrimesterId = searchParams.get('trimester_id') ?? currentTrimesterId;

  if (!reportDefinition) {
    return <Navigate to="/relatorios" replace />;
  }

  return (
    <MainLayout showBack onBack={() => navigate('/')}>
      <div className="space-y-6">
        <header className="space-y-2">
          <h1 className="text-2xl font-bold text-slate-900">{reportDefinition.title}</h1>
          <p className="text-sm text-slate-500">{currentTrimester.label}</p>
        </header>

        {routeTrimesterId ? (
          reportDefinition.id === 'offerings-period' ? (
            <OfferingsReportView quarterId={routeTrimesterId} quarterLabel={currentTrimester.label} />
          ) : (
            <EbdReportsHubView quarterId={routeTrimesterId} reportId={reportDefinition.id} />
          )
        ) : (
          <div className="rounded-2xl border border-dashed border-slate-300 bg-slate-50 p-4 text-sm text-slate-600">
            Selecione um trimestre para visualizar os relatórios.
          </div>
        )}
      </div>
    </MainLayout>
  );
};

export default ReportDetailsPage;
